const methods = {
    // Consultamos al back las cuentas y productos con descuadres
    async fetchData() {
        this.loading = true;
        const operationsParams = {
            $limit: 15,
            $expand: 'interveners'
        };
        operationsParams['$filter'] = JSON.stringify({
            account_id_object: [{ eq: this.account }],
            key_product: [{ eq: this.productSelected.key_product }]
        });
        try {
            const res = await this.$operationsService.getOperations('', { params: operationsParams });
            const { operations } = res.data;
            this.lastOperations = operations;
            this.loading = false;
        } catch (error) {
            this.$toast.error(`Error`, `No se han podido obtener los últimos movimientos.`);
        }
    }
};

export default methods;
